<template>
  <router-view
    v-if="isInitialized"
    :loading="loading"
    :images="images"
    :meta="meta"
    @image:search="onSearch"
    @image:pagination="onPagination"
  ></router-view>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'ImageHome',
  data() {
    return {
      loading: true,
      isInitialized: false,
    }
  },
  computed: {
    ...mapGetters('image', { getImageArray: 'getArray', meta: 'getMeta' }),
    ...mapGetters('user', { getUserNameById: 'getUserNameById' }),
    images() {
      return this.getImageArray.map((image) =>
        image.updated_by
          ? { ...image, updated_by: this.getUserNameById(image.updated_by) }
          : { ...image, updated_by: '' }
      )
    },
  },
  methods: {
    ...mapMutations('image', { addImageFilter: 'ADD_FILTER', setPageOrder: 'SET_SORT' }),
    ...mapActions('image', { getImages: 'readCollection' }),

    resetPageNumber() {
      this.addImageFilter({ key: 'pageNumber', value: 1 })
    },
    onSearch(value) {
      this.resetPageNumber()
      this.addImageFilter({ key: 'search', value })
      this.fetch()
    },
    onPagination(value) {
      this.addImageFilter({ key: 'pageNumber', value })
      this.fetch()
    },
    async fetch() {
      this.loading = true
      await this.getImages()
      this.loading = false
    },
  },
  async created() {
    this.addImageFilter({ key: 'pageSize', value: 30 })
    this.setPageOrder({ key: 'created_at', value: 'DESC' })
    await this.fetch()
    this.isInitialized = true
  },
}
</script>

<style lang="scss" scoped></style>
